import ReactHtmlParser from 'react-html-parser'
let captcha_value = ''
let captchaCharCount = 6
let backgroundColor_value = ''
let fontColor_value = ''
let charMap_value = ''
export interface IIseCaptchaProps {
  charactersCount?: number
  reloadText?: string | ''
  reloadColor?: string | ''
  backgroundColor?: string | ''
  fontColor?: string | ''
  charMap?: 'upper' | 'lower' | 'numbers' | 'special_char'
}
// let captcha_value = '';
// let captchaCharCount = 6;
// let backgroundColor_value = '';
// let fontColor_value = '';
// let charMap_value = '';
let LoadCanvasTemplate_HTML =
  '<div><canvas id="ise_captcha_canv"></canvas><div><a id="ise_captcha_reload"  style="cursor: pointer; color: blue">Reload Captcha</a></div></div>'
 let LoadCanvasTemplate_NoReload_HTML =
   '<div title="براي توليد كد امنيتي جديد كليك نماييد" style="text-align:center;cursor:pointer;"><canvas id="ise_captcha_canv"></canvas><div>';
export const generateCaptcha = () => {
  // backgroundColor_value = backgroundColor;
  // fontColor_value = props.fontColor;
  // charMap_value = props.charMap;
  // captchaCharCount = charactersCount;
  let retVal = ''
  let charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  if (charMap_value === 'upper') {
    charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  } else if (charMap_value === 'lower') {
    charset = 'abcdefghijklmnopqrstuvwxyz0123456789'
  } else if (charMap_value === 'numbers') {
    charset = '0123456789'
  } else if (charMap_value === 'special_char') {
    charset = "~`!@#$%^&*()_+-=[]{}|:'<>,.?/"
  }

  const length = captchaCharCount

  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n))
  }

  const captcha = retVal

  captcha_value = captcha

  // let length_height_canvas = Math.round(parseInt(length) / 3);
  const reloadButton: any = document.getElementById('ise_captcha_reload')
  const canvas: any = document.getElementById('ise_captcha_canv')
  const ctx = canvas.getContext('2d')
  // img = document.getElementById('image');
  const text = captcha
  // let x = 12.5;
  // let y = 15;
  const lineheight = 30

  // let canvas_height = (parseInt(length) - parseInt(length_height_canvas)) * 20;
  const lines = text.split('\n')
  //   let lineLengthOrder = lines.slice(0).sort(function (a, b) {
  //     return b.length - a.length;
  //   });
  ctx.canvas.width = length * 25
  ctx.canvas.height = lines.length * lineheight

  ctx.fillStyle = backgroundColor_value
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  ctx.textBaseline = 'middle'
  ctx.font = 'italic 20px Arial'
  ctx.fillStyle = fontColor_value

  let num = 0
  for (let i = 0; i < length; i++) {
    num = num + 1
    const heigt_num = 20 * num
    ctx.fillText(
      retVal[i],
      heigt_num,
      Math.round(Math.random() * (15 - 12) + 12)
    )
  }
  if(reloadButton)
  {
    reloadButton.onclick = function () {
    generateCaptcha()
  }
}

   canvas.onclick = function () {
     generateCaptcha();
   };
}
export const validateCaptcha = (userValue: string, reload = true) => {
  if (userValue.toLowerCase() !== captcha_value.toLowerCase()) {
    if (reload === true) {
      generateCaptcha()
    }

    return false
  } else {
    return true
  }
}
export const IseCaptcha = (props: IIseCaptchaProps) => {
  const {
    reloadText,
    backgroundColor,
    charactersCount,
    charMap,
    fontColor,
    reloadColor
  } = props
  captchaCharCount = charactersCount ?? 6
  backgroundColor_value = backgroundColor ?? 'white'
  charMap_value = charMap ?? 'upper'
  fontColor_value = fontColor ?? 'black'
  let reload_text = reloadText ?? 'كد امنيتي جديد'
  let reload_color = reloadColor ?? 'black'
  LoadCanvasTemplate_HTML =
    '<div><canvas id="ise_captcha_canv" style="background-color: blue;"></canvas><div><a id="ise_captcha_reload"  style="cursor: pointer; color: blue">Reload Captcha</a></div></div>'

  if (reloadText) {
    reload_text = reloadText
  }

  if (reloadColor) {
    reload_color = reloadColor
  }

  if (reload_text === '') {
    reload_text = 'Reload Captcha'
  }

  if (reload_color === '') {
    reload_color = 'blue'
  }

  LoadCanvasTemplate_HTML =
    '<div title="براي توليد كد امنيتي جديد كليك نماييد" style="text-align:center;cursor:pointer;"><canvas id="ise_captcha_canv"></canvas><div><button id="ise_captcha_reload"  style=" font-family: tahoma; cursor: pointer; color: ' +
    reload_color +
    '">' +
    reload_text +
    '</button></div></div>'
    LoadCanvasTemplate_NoReload_HTML =
    '<div title="براي توليد كد امنيتي جديد كليك نماييد" style="text-align:center;cursor:pointer;"><canvas id="ise_captcha_canv"></canvas><div>'
    if(reloadText)
    return ReactHtmlParser(LoadCanvasTemplate_HTML)

    return ReactHtmlParser(LoadCanvasTemplate_NoReload_HTML)

}
//export default IseCaptcha
